var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.6003 3.45508L7.76318 6.63623L1.92607 3.45508V2.18262L7.76318 5.36377L13.6003 2.18262M13.6003 0.910156H1.92607C1.11618 0.910156 0.466797 1.4764 0.466797 2.18262V9.81738C0.466797 10.1549 0.620542 10.4785 0.894209 10.7171C1.16788 10.9558 1.53905 11.0898 1.92607 11.0898H13.6003C13.9873 11.0898 14.3585 10.9558 14.6322 10.7171C14.9058 10.4785 15.0596 10.1549 15.0596 9.81738V2.18262C15.0596 1.4764 14.4029 0.910156 13.6003 0.910156Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailTwo);
export default __webpack_public_path__ + "static/media/mailTwo.8a2e92500b05646f54256d33c8fad29b.svg";
export { ForwardRef as ReactComponent };